import googlemapLogoUrl from '../../images/contact/social-media/googlemap.svg';
import gmailLogoUrl from '../../images/contact/social-media/gmail.svg';
import whatsappLogoUrl from '../../images/contact/social-media/whatsapp.svg';

const contactInfo = [
  {
    imageUrl: googlemapLogoUrl,
    title: 'Address',
    description: '26 March st, El Lebeny axis, Faisal, Giza, Egypt.',
    url: 'https://goo.gl/maps/6zNf86zZocAiviJGA',
    target: '_blank',
  },
  {
    imageUrl: gmailLogoUrl,
    title: 'Email',
    description:
      'amrsaadabdallah@gmail.com, Send your query at our email and get a free estimation.',
    url: 'mailto:amrsaadabdallah',
    target: '_self',
  },
  {
    imageUrl: whatsappLogoUrl,
    title: 'Whatsapp',
    description:
      "Ping me through whatsapp (+20) 109-775-6067. We'll reply you ASAP",
    url: 'https://wa.me/+2001097756067',
    target: '_blank',
  },
];

export default contactInfo;
